import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";

export const GUTTER_WIDTH = 20;

const styles = StyleSheet.create({
	container: {
		paddingLeft: GUTTER_WIDTH / 2,
		paddingRight: GUTTER_WIDTH / 2,
		margin: "0 auto",
	},
});

export default class Container extends PureComponent {
	static propTypes = {
		children: PropTypes.node.isRequired,
		fluid: PropTypes.bool.isRequired,
		maxWidth: PropTypes.number.isRequired,
	};

	static defaultProps = {
		fluid: false,
		maxWidth: 960,
	};

	getWrappedInstance = () => {
		return this._wrapped;
	};

	_setRef = ref => {
		this._wrapped = ref;
	};

	render() {
		let style;
		if (!this.props.fluid) {
			style = { maxWidth: this.props.maxWidth };
		}

		return (
			<div className={css(styles.container)} ref={this._setRef} style={style}>
				{this.props.children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/grid/Container.js